import { track } from "@/lib/api";

/**
 * Site-wide rule: when a card has exactly ONE affiliate destination, the whole card is that link.
 * Image, heading, description, padding and the green button all live inside this single anchor, so
 * a click anywhere navigates once and reports exactly one conversion. Cards offering several
 * merchants, or an internal guide/tool choice, must keep their separate links and not use this.
 */
export const AffiliateCardLink = ({
  href,
  ariaLabel,
  testId,
  trackPayload,
  innerRef,
  rel = "sponsored nofollow noopener",
  className = "",
  children,
}) => (
  <a
    ref={innerRef}
    href={href}
    target="_blank"
    rel={rel}
    aria-label={ariaLabel}
    data-testid={testId}
    onClick={() => trackPayload && track(trackPayload)}
    className={`group relative cursor-pointer transition-shadow duration-300 hover:shadow-[0_18px_40px_-24px_rgba(0,0,0,0.45)] hover:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 ${className}`}
  >
    {children}
  </a>
);

/** The existing green CTA, styled identically but rendered inside the card's single anchor. */
export const AffiliateCardButton = ({ testId, className = "", children }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-sage text-white text-[12.5px] tracking-[0.14em] uppercase font-semibold group-hover:bg-sage-dark transition-colors duration-300 ${className}`}
  >
    {children}
  </span>
);
